import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {catchError, map} from 'rxjs/operators';

import {HttpClient} from '@angular/common/http';
import {SafeHtml} from '@angular/platform-browser';
import {Router} from '@angular/router';
import {GridService} from 'app/core-ui/abstract/basegrid/grid.service';
import {ConfigService} from 'app/core-ui/abstract/services/config.service';
import {EventsEmitterService} from 'app/core-ui/abstract/services/emitter.service';
import {LogService} from 'app/core-ui/abstract/services/log.service';

@Injectable()
export class NotificationBuilderDetailsService extends GridService {
  constructor(
    http: HttpClient,
    configService: ConfigService,
    eventsEmitterService: EventsEmitterService,
    router: Router,
    logger: LogService,
  ) {
    super(
      http,
      configService,
      eventsEmitterService,
      router,
      logger,
      'NotificationBuilderDetailsService',
    );
  }

  getNotificationData(eventType: string, langId: number, mediaType: string): Observable<any> {
    let serviceUrl =
      this.baseUrl +
      this.serviceName +
      '/notification-data?eventType=' +
      eventType +
      '&langId=' +
      langId +
      '&mediaType=' +
      mediaType;
    return this.request(serviceUrl).pipe(map(super.extractData), catchError(super.handleError));
  }
  getHtmlData(eventType: string, langId: number, mediaType: string): Observable<SafeHtml> {
    let serviceUrl =
      this.baseUrl +
      this.serviceName +
      '/html-data?eventType=' +
      eventType +
      '&langId=' +
      langId +
      '&mediaType=' +
      mediaType;
    return this.request(serviceUrl, {responseType: 'text'}).pipe(catchError(super.handleError));
  }
  getTags(eventType: string): Observable<any> {
    let serviceUrl = this.baseUrl + this.serviceName + '/tags-data?eventType=' + eventType;
    return this.request(serviceUrl).pipe(map(super.extractData), catchError(super.handleError));
  }

  updateJsonContent(postData: any): Observable<any> {
    let serviceUrl = this.baseUrl + this.serviceName + '/update-json-content?';
    return this.request(serviceUrl, this.setPostParams(postData)).pipe(
      catchError(super.handleError),
    );
  }

  updateHtmlContent(postData: any): Observable<any> {
    let serviceUrl = this.baseUrl + this.serviceName + '/update-html-content';
    return this.request(serviceUrl, this.setPostParams(postData)).pipe(
      catchError(super.handleError),
    );
  }
}
